module.exports = __webpack_public_path__ + "static/media/power-plant.56cf8dbc.jpg";